package dev.lingvo.site.components.studio.compose

/** Produces a complete zlib stream, including its header and Adler-32 trailer. */
fun interface Deflate {
    /** Compresses [input] without changing it. */
    suspend fun compress(input: ByteArray): ByteArray
}

/** Portable zlib fallback using DEFLATE stored blocks (no compression). */
object StoredDeflate : Deflate {
    override suspend fun compress(input: ByteArray): ByteArray = compressStored(input)

    /** Synchronous equivalent for environments without browser compression. */
    fun compressStored(input: ByteArray): ByteArray {
        val blocks = maxOf(1L, (input.size.toLong() + 65534L) / 65535L)
        val size = input.size.toLong() + blocks * 5L + 6L
        require(size <= Int.MAX_VALUE) { "Zlib stream is too large" }
        val output = ByteArray(size.toInt())
        output[0] = 0x78
        output[1] = 0x01
        var source = 0
        var target = 2
        do {
            val length = minOf(65535, input.size - source)
            output[target++] = if (source + length == input.size) 1 else 0
            output[target++] = length.toByte()
            output[target++] = (length ushr 8).toByte()
            output[target++] = length.inv().toByte()
            output[target++] = (length.inv() ushr 8).toByte()
            input.copyInto(output, target, source, source + length)
            source += length
            target += length
        } while (source < input.size)
        var a = 1
        var b = 0
        for (byte in input) {
            a = (a + (byte.toInt() and 255)) % 65521
            b = (b + a) % 65521
        }
        PngChunks.writeInt(output, target, (b shl 16) or a)
        return output
    }
}
